import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { notification } from '@spark/ui-components/utils/notification';
import { getMotoristaById, deleteMotorista } from '@spark/services';

export const useMotoristaDetalhes = () => {
  const { id } = useParams();
  const history = useHistory();
  const [motorista, setMotorista] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    loadMotorista();
  }, [id]);

  const loadMotorista = async () => {
    try {
      setLoading(true);
      const response = await getMotoristaById(id);
      const responseData = response?.data || response;
      setMotorista(responseData);
    } catch (err) {
      console.error('Erro ao carregar motorista:', err);
      notification.error(
        err?.message || 'Erro ao carregar motorista',
        'Erro ao carregar'
      );
      history.push('/pages/motoristas');
    } finally {
      setLoading(false);
    }
  };

  const handleVoltar = () => {
    history.push('/pages/motoristas');
  };

  const handleEditar = () => {
    history.push(`/pages/motoristas/edicao/${id}`);
  };

  const handleExcluir = async () => {
    const identificador = motorista?.Nome || id;

    if (!window.confirm(`Tem certeza que deseja excluir o motorista ${identificador}?`)) {
      return;
    }

    try {
      setDeleteLoading(true);
      await deleteMotorista(id);
      notification.success('Motorista excluído com sucesso!');
      history.push('/pages/motoristas');
    } catch (error) {
      console.error('Erro ao excluir motorista:', error);
      notification.error(
        error?.message || 'Não foi possível excluir o motorista.',
        'Erro ao excluir'
      );
    } finally {
      setDeleteLoading(false);
    }
  };

  return {
    motorista,
    loading,
    deleteLoading,
    handleVoltar,
    handleEditar,
    handleExcluir,
  };
};
